import React, { useEffect, useState, useRef, useCallback } from 'react';
import { useProjectState, setProjectState } from '@starflow/app/store';
import { delUnit } from '@starflow/app/helpers/flow';
import { localFileExt, NodeState } from '../../constants';
import { exportJsonAsFile } from '../../../../utils/file';
import { registerType } from '../../../../constants';
import uniqid from 'uniqid';
import { translate } from '@shakkerai/util-i18n';

const RightClick = React.memo(() => {
  const nodeMap = useProjectState('nodeMap');
  const units = useProjectState('units');
  const [style, setStyle] = useState({
    position: 'fixed',
    left: 300,
    top: 200,
    display: 'none',
    zIndex: 10,
  });
  const [nodeInfo, setCurrentNodeInfo] = useState({});
  // 右键菜单ref
  const rightClickRef = useRef();

  // 右键点击
  const handleContextMenu = (event) => {
    const dataset = event.target.dataset;
    // 屏蔽默认右键事件
    event.preventDefault();
    // event.stopPropagation();
    if (!Object.values(registerType).some((type) => type === dataset.type)) {
      return;
    }
    setCurrentNodeInfo(dataset);
    // 先显示才能捕捉到右键菜单Ref
    // 获得点击的位置
    let { clientX, clientY } = event;
    // 文档显示区的宽度
    const screenW = window.innerWidth;
    const screenH = window.innerHeight;
    // 右键菜单的宽度
    const rightClickRefW = rightClickRef.current.offsetWidth;
    const rightClickRefH = rightClickRef.current.offsetHeight;
    // right为true，说明鼠标点击的位置到浏览器的右边界的宽度可以放下contextmenu。
    // 否则，菜单放到左边。
    const right = screenW - clientX > rightClickRefW;
    const top = screenH - clientY > rightClickRefH;
    // 赋值右键菜单离鼠标一些距离
    clientX = right ? clientX + 6 : clientX - rightClickRefW - 6;
    clientY = top ? clientY + 6 : clientY - rightClickRefH - 6;
    setStyle({
      ...style,
      left: clientX,
      top: clientY,
      display: true,
    });
  };

  const setShowFalse = () => {
    setStyle({
      ...style,
      display: 'none',
    });
  };

  // 生命周期监听
  useEffect(() => {
    document.addEventListener('contextmenu', handleContextMenu);
    document.addEventListener('click', setShowFalse, true);
    document.addEventListener('scroll', setShowFalse, true);
    return () => {
      document.removeEventListener('contextmenu', handleContextMenu);
      document.removeEventListener('click', setShowFalse, true);
      document.removeEventListener('scroll', setShowFalse, true);
    };
  }, []);

  const downloadUnit = (id) => {
    const target = nodeMap[id];
    const name = `${target.data.label}.${localFileExt}`;
    exportJsonAsFile(target, name);
  };
  const editTitle = (id) => {
    const targetState = nodeMap[id]?.data.state ?? [];
    if (!targetState.some((s) => s === NodeState.TextEditing)) {
      targetState.push(NodeState.TextEditing);
      setProjectState({
        nodeMap: {
          ...nodeMap,
          [id]: {
            ...nodeMap[id],
            data: {
              ...nodeMap[id].data,
              state: targetState,
            },
          },
        },
      });
    }
  };
  const copy = (id) => {
    const newId = id.split('-').slice(0, 2).join('-') + '-' + uniqid();
    const target = nodeMap[id];
    setProjectState({
      units: {
        nodes: units.nodes.concat([newId]),
      },
      nodeMap: {
        ...nodeMap,
        [newId]: {
          ...target,
          id: newId,
          data: {
            ...target.data,
            id: newId,
          },
        },
      },
      currentNodeId: newId,
    });
  };

  const registerTypes = useCallback(
    ({ type, id }) => {
      switch (type) {
        case registerType.UNIT:
          return (
            <ul className="flex flex-col w-full">
              <li onClick={() => editTitle(id)} className="hover:bg-[#424141] cursor-pointer leading-[34px] px-4">
                {translate('flow_g_op1')}
              </li>
              <li onClick={() => downloadUnit(id)} className="hover:bg-[#424141] cursor-pointer leading-[34px] px-4">
                {translate('flow_g_op2')}
              </li>
              {units.nodes?.length > 1 && (
                <li onClick={() => delUnit(id)} className="hover:bg-[#424141] cursor-pointer leading-[34px] px-4">
                  {translate('flow_g_op3')}
                </li>
              )}
              <li onClick={() => copy(id)} className="hover:bg-[#424141] cursor-pointer leading-[34px] px-4">
                {translate('flow_g_op4')}
              </li>
            </ul>
          );
        case registerType.FLOW:
          return (
            <ul className="flex flex-col w-full">
              <li onClick={() => editTitle(id)} className="hover:bg-[#424141] cursor-pointer leading-[34px] px-4">
                {translate('flow_g_op1')}
              </li>
            </ul>
          );
      }
    },
    [nodeInfo, units],
  );
  return (
    <div ref={rightClickRef} className="bg-[#2c2c2c] py-2 text-white text-xs rounded-sm" style={style}>
      {registerTypes(nodeInfo)}
    </div>
  );
});

export default RightClick;
